// At most one viewport request in flight; keep a trailing refresh when commits
// arrive during the request. Do not reset the timer on continuous activity.
const pending = new WeakMap()
export function schedulePasteRefresh(app, store, tableId) {
  if (store.getters['table/getSelectedId'] !== tableId) return
  let state = pending.get(store)
  if (!state || state.tableId !== tableId) {
    state = { tableId, dirty: false, running: false }
    pending.set(store, state)
  }
  state.dirty = true
  if (state.running) return
  state.running = true
  const flush = () => {
    if (
      pending.get(store) !== state ||
      store.getters['table/getSelectedId'] !== tableId
    ) {
      state.running = false
      return
    }
    state.dirty = false
    let completed = false
    const done = () => {
      if (completed) return
      completed = true
      clearTimeout(timeout)
      if (state.dirty) setTimeout(flush, 1000)
      else state.running = false
    }
    const timeout = setTimeout(done, 30000)
    app.$bus.$emit('table-refresh', {
      tableId,
      background: true,
      sourceEvent: 'paste',
      callback: done,
    })
  }
  setTimeout(flush, 1000)
}
